import React from 'react'
import { useMyHook } from '../../NewContext'
import HeaderDesktop from "./HeaderDesktop"
import HeaderMobile from "./HeaderMobile"



const Header = () => {
  
const { collapse, toggleMenuCollapse, windowSize } = useMyHook()

  return (
    <>
      {windowSize > 1024 ? <HeaderDesktop/> : <HeaderMobile collapse={collapse} toggleMenuCollapse={toggleMenuCollapse} />}
    </>
  )
}

export default Header